import React from "react";
import './style.css';

const Loader: React.FC = () => {
  return (
    <div className="loader-container">
      <div className="logo">
        <img className="logo-base" src="/img/logo.png" alt="" aria-hidden decoding="async" />
        <img className="logo-fill" src="/img/logo.png" alt="Loader" decoding="async" />
      </div>
    </div>
  );
};

export default Loader;
